import React from "react";

export const Logo = ({ color, className, iconOnly, style, isDarkBg }) => {
  const fillColor = color || "currentColor";

  return iconOnly ? (
    <svg
      style={style}
      className={className}
      fill={fillColor}
      pointerEvents="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 359.7 357.8"
      alt="Common Room logo icon"
    >
      <path d="M329.6,143,215.7,29.2a50.7,50.7,0,0,0-71.7,0L30.1,143a51,51,0,0,0,0,71.8L144,328.6a50.9,50.9,0,0,0,71.7,0L329.6,214.8A51,51,0,0,0,329.6,143ZM225.7,224.8l-45.8,45.8L88.1,178.9l91.8-91.7L225.7,133l-45.8,45.9Z" />
    </svg>
  ) : (
    <span style={{ position: "relative", display: "inline-block" }}>
      {isDarkBg && (
        <span
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "150%",
            height: "150%",
            background: "radial-gradient(ellipse, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 70%)",
            zIndex: 0,
          }}
        />
      )}
      <img
        src={`/static/img/logos/common-room-logo-` + (isDarkBg ? "white" : "color") + `.png`}
        style={{ position: "relative", zIndex: 1, ...style }}
        alt="Common Room logo full"
        className={className}
      />
    </span>
  );
};
